import App from './app';
import MenuApp from './classes/class-menu-app';

(() => {
  /**
   * @description парсим нужные меню и создаем одно для мобил
   * */
  const toggle = document.querySelector('.js-menu-toggle');
  const menuRoots = document.querySelectorAll('.js-menu-root');
  if (!menuRoots.length) return false;
  const dataRoots = [...menuRoots].map((root) => {
    const { title, category, collapse, url, order } = root.dataset;
    return {
      ul: root.tagName === 'UL' ? root : root.querySelector('ul'),
      title,
      category,
      collapse,
      url,
      order,
    };
  });
  dataRoots.sort((a, b) => {
    if (!a.order && !b.order) return 0;
    if (!a.order && b.order) return 1;
    if (a.order && !b.order) return -1;
    return a.order - b.order;
  });
  function createData(data) {
    function parseItem(li) {
      const link = li.querySelector('.c-menu__item-link');
      const dropdown = li.querySelector('ul');
      const { count } = link.dataset;
      const url = link.href;
      const active = link.closest('.c-menu__item').classList.contains('is-active');
      const title = link.textContent || '';
      let children = null;
      if (dropdown) {
        children = [...dropdown.children].map(item => parseItem(item));
      }
      return {
        title,
        url,
        children,
        active,
        count,
      };
    }
    function makeRoot(root) {
      if (root.category) {
        return [{
          category: root.category,
          children: [...root.ul.children].map(item => parseItem(item)),
        }];
      }
      if (root.title) {
        return [{
          title: root.title,
          collapse: root.collapse,
          children: [...root.ul.children].map(item => parseItem(item)),
        }];
      }
      return [...root.ul.children].map(item => parseItem(item));
    }
    return [].concat(...data.map(root => makeRoot(root)));
  }
  const menuMobile = new MenuApp(createData(dataRoots), {
    title: 'Меню',
    footerHtml: (() => {
      const btn = document.getElementById('js-btn-activate');
      if (btn) {
        const newBtn = btn.cloneNode(true);
        newBtn.dataset.action = 'close';
        return newBtn.outerHTML;
      }
      return '';
    })(),
  });
  menuMobile.onOpen = () => {
    if (toggle) toggle.classList.add('is-active');
  };
  menuMobile.onClose = () => {
    if (toggle) toggle.classList.remove('is-active');
  };
  if (toggle) {
    toggle.onclick = (event) => {
      event.preventDefault();
      if (menuMobile && menuMobile.active) {
        menuMobile.close();
      } else if (menuMobile) {
        menuMobile.open();
      }
    };
  }
  App.breakpoints.onBreakpoint(
    'xxs xs sm md',
    () => {
      document.body.appendChild(menuMobile.menu);
      document.body.appendChild(menuMobile.overlay);
    },
    () => {
      if (menuMobile && menuMobile.close) menuMobile.close();
    },
  );
  return menuMobile;
})();

(($) => {
  const menu = $('.js-menu-main');
  menu.find('.has-dropdown').each(function () {
    const dropdown = $(this).children('.c-menu__dropdown');
    if (!dropdown.length) {
      $(this).removeClass('has-dropdown');
      return false;
    }
    if (!$(this).is('.is-expanded')) {
      dropdown.hide(0);
      $(this).addClass('is-collapsed');
    }
    return dropdown;
  });
  menu.on('click', '[data-dropdown]', function (event) {
    const item = $(this).closest('.has-dropdown');
    const dropdown = item.children('.c-menu__dropdown');
    if (dropdown.length) {
      event.preventDefault();
      item.toggleClass('is-expanded is-collapsed');
      dropdown.stop(false).slideToggle();
    }
  });
})(jQuery);
